<template>

  <div class="page_container">



    <div class="study_data">
      <div class="study_data_item">
        <div class="study_data_item_top">{{ consecutiveCheckInDays }}</div>
        <div class="study_data_item_bottom">连续签到</div>
      </div>

      <div class="study_data_item">
        <div class="study_data_item_top">{{ totalCheckInDays }}</div>
        <div class="study_data_item_bottom">累计签到</div>
      </div>

      <div class="study_data_item">
        <div class="study_data_item_top">{{ formattedLearnTime }}</div>
        <div class="study_data_item_bottom">累计学习时间</div>
      </div>

    </div>


   

    <van-calendar class="calendar"
     
      :formatter="formatter"
      :poppable="false"
      switch-mode="year-month"
      :show-confirm="false"
      :show-title="false"
       
    >
 
    

    </van-calendar>

    <!-- <div class="check_in">补签</div> -->
    

    

  </div>

  
 



  
  

  
    
  </template>
  
  <script setup >


import { ref,computed, onMounted } from 'vue';

import {getstudyData} from '@/api/apiService';


const checkInDates = ref([]);
import { useRouter } from 'vue-router';

const consecutiveCheckInDays = ref(0);
const totalCheckInDays = ref(0);
const totalStudyTime = ref(0);
const router = useRouter();

// Formatter function to customize the appearance of the calendar days

// 获取今天的日期
const today = new Date();
today.setHours(0, 0, 0, 0); // 将时间部分设置为 00:00:00
const todayTimestamp = today.getTime();
const formatter = (day) => {
  const timestamp = day.date.getTime();

  if (checkInDates.value.includes(timestamp)) {
    
    // day.topInfo = 'Check-in';
    day.type = 'disabled';
    
    day.className = "check-day";
    
  }

  if (timestamp > todayTimestamp) {
    day.type = 'disabled';
  }

  if (timestamp === todayTimestamp) {
    day.text = '今';
  }


  

  return day;
};

const formattedLearnTime = computed(() => {
      
      if (totalStudyTime.value < 1000) {
        return `${totalStudyTime.value.toFixed(0)}m`;
      } else {
        const totalHours = totalStudyTime.value / 60;
        return `${totalHours.toFixed(1)}h`;
      }
    });

// Open the calendar when the component is mounted
onMounted(() => {

  getstudyData().then((res) => {
    if (res.code === 0 && res.msg === 'success'){

      checkInDates.value = res.userStudyData.allCheckInDate.map(dateStr => new Date(dateStr).setHours(0, 0, 0, 0));


    consecutiveCheckInDays.value = res.userStudyData.consecutiveCheckInDays;
    totalCheckInDays.value = res.userStudyData.totalCheckInDays;
    totalStudyTime.value = res.userStudyData.totalLearnTimes/60000;

    }else{
      router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    }
    
    



  }).catch(() => {
    router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
  });

  
  
  
  
});









// import { useRouter } from 'vue-router';

//   const router = useRouter();

//   function toFenXiangGuan() {
//     // router.push({ name: 'FenXiangGuan' });
//     const url = router.resolve({ name: 'FenXiangGuan' }).href;
//     window.location.href = url;
//   }

//   function toPingLunHuiKui() {
//     // router.push({ name: 'PingLunHuiKui' });
//     const url = router.resolve({ name: 'PingLunHuiKui' }).href;
    
//     window.location.href = url;
//   }
 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    
    
  }

  :deep(.van-calendar__header) {
    flex-shrink: 0;
    box-shadow: 0 1px 0 0 #f7f7f7;
    
}

  .study_data{
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin-top: 0.1rem;
    margin-bottom: 0.5rem;
    width: 90%;
  }

  .study_data_item{
    flex:1;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    
  }

  .study_data_item_top{
    font-size: 0.7rem;
    font-weight: bold;
  }

  .study_data_item_bottom{
    font-size: 0.4rem;
  }
  .calendar{
    flex: 1;
    width: 90%;
    padding-bottom: 0.4rem; /* 确保内容不会被底部布局遮挡，调整高度以适应底部布局的高度 */
    background: white;
  }

  .van-calendar {
    background-color: #ffffff;
  }

  
  /* 隐藏 van-calendar 组件中的背景月份 */
:deep(.van-calendar__month-mark) {
  display: none;
}

  :deep(.check-day) {
    background-color: red !important;
  color: white !important;
  border-radius: 50%;
  border: calc(var(--van-calendar-day-height) *0.1) solid #ffffff !important; /* 设置边框为 --van-calendar-day-height 的 1/10 */
  box-sizing: border-box;
  
  height: auto;
  aspect-ratio: 1 / 1 !important; /* 确保高度等于宽度 */
  
}


:deep(.van-calendar__day){  
  height: auto;
  aspect-ratio: 1 / 1 !important; /* 确保高度等于宽度 */
}

:deep(.van-calendar__day){  
  height: auto;
  aspect-ratio: 1 / 1 !important; /* 确保高度等于宽度 */
}
:deep(.van-calendar__selected-day){
  height: auto;
  aspect-ratio: 1 / 1 !important; /* 确保高度等于宽度 */
  margin: calc(var(--van-calendar-day-height) *0.1);
}


.check_in{
  display: flex;
  flex: 1;
  align-content: center;
  justify-content: center;
  align-items: center;
  border: 1px solid gray; /* 添加灰色边框 */
  
  border-radius: 0.3rem;
  width: 40%;
  padding: 0.1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.5rem;
  cursor: pointer;
}




  </style>